import React, { type FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { type RootState } from '../../../redux/store'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'

import {
  DownloadActiveMetersReportButton,
  GenerateTransferFileDialogActionButton,
  MetersHeader,
  MetersViewContainer,
  SetCompanyAlarmButton
} from './MetersView.style'
import { MetersTable } from '../meters-table/MetersTable'
import { SearchBar } from '../../common/search-bar/SearchBar'
import { Filters } from '../filters/Filters'
import { CustomerSelectionFilter } from '../filters/CustomerSelectionFilter'
import { GenerateTransferFileDialog } from '../GenerateTransferFileDialog'
import KokaLogo from '../../../assets/koka_logo.png'
import generateTransferFileDialogIcon from '../../../assets/icon-save.svg'
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms'
import {
  SearchMetersDataAction,
  SearchStringChangedAction,
  SetCompanyAlarmDialogVisibilityAction,
  SetMeterActivePageAction,
  ToggleDownloadDialogAction
} from '../../../redux/meter-table/meter-table-actions'
import { DownloadActiveMetersAction } from '../../../redux/reports/reports-actions'
import { SetCompanyAlarmDialog } from '../set-company-alarm-dialog/SetCompanyAlarmDialog'

export const MetersView: FC = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const isAdmin = useAppSelector((state: RootState) => state.auth.isAdmin)
  const [searchString, setSearchString] = useState('')
  const [searchTextTimeout, setSearchTextTimeout] = useState<ReturnType<typeof setTimeout> | undefined>(undefined)

  const onSearchTextChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSearchString(e.target.value)
    clearTimeout(searchTextTimeout)
    setSearchTextTimeout(setTimeout(() => {
      dispatch(SearchStringChangedAction(e.target.value))
      dispatch(SetMeterActivePageAction({ activePage: 1 }))
      dispatch(SearchMetersDataAction(e.target.value))
    }, 500))
  }

  const setCompanyAlarmDialogHandler = (): void => {
    dispatch(SetCompanyAlarmDialogVisibilityAction(true))
  }

  return (
        <MetersViewContainer>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 10px' }}>
                <MetersHeader>
                    <img style={{ height: '30px', marginBottom: '-5px' }} src={KokaLogo} alt="hydronet-logo"/>
                </MetersHeader>
                <div>
                    <SetCompanyAlarmButton
                        startIcon={<AccessAlarmsIcon/>}
                        onClick={() => {
                          setCompanyAlarmDialogHandler()
                        }}
                        data-testid='set-company-alarm-button'
                    >
                        {t('alarms.edit')}
                    </SetCompanyAlarmButton>
                    {isAdmin && (<DownloadActiveMetersReportButton
                        startIcon={<img src={generateTransferFileDialogIcon} alt='download-active-meters-report'/>}
                        onClick={() => dispatch(DownloadActiveMetersAction())}
                    >
                        {t('download_active_meters_report')}
                    </DownloadActiveMetersReportButton>)}
                    <GenerateTransferFileDialogActionButton
                        startIcon={<img src={generateTransferFileDialogIcon} alt='generate-transfer-file'/>}
                        onClick={() => dispatch(ToggleDownloadDialogAction())}
                    >
                        {t('companyIntegrations.generateTransferFile')}
                    </GenerateTransferFileDialogActionButton>
                </div>
            </div>
            <GenerateTransferFileDialog/>
            <SetCompanyAlarmDialog/>

            <div style={{ display: 'flex', alignItems: 'left', borderTop: 'solid 1px #edf2f9', padding: '10px' }}>
                <SearchBar onChange={onSearchTextChange} searchValue={searchString}/>
                <Filters/>
                {isAdmin && <CustomerSelectionFilter/>}
            </div>
            <MetersTable/>
        </MetersViewContainer>
  )
}
